import { useState, useRef, ReactNode } from "react";
import { useIntersectionObserver } from "~/hooks/useIntersectionObserver";
interface AnimatedLayoutProps {
  children: ReactNode;
  className?: string;
  animationClass?: string;
  hiddenClass?: string;
  direction?: "left" | "right" | "top" | "bottom";
  threshold?: number; // Allow customization of the visibility threshold
  debounceDelay?: number; // Debounce delay to prevent flickering
}

export const GlobalAnimatedLayout = ({
  children,
  className = "",
  animationClass = "opacity-100",
  hiddenClass = "opacity-0",
  direction = "left",
  threshold = 0.7, // Default to 70%
  debounceDelay = 50, // Default debounce delay
}: AnimatedLayoutProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const targetRef = useRef<HTMLDivElement | null>(null);

  const slideInClass = {
    left: "translate-x-0",
    right: "translate-x-0",
    top: "translate-y-0",
    bottom: "translate-y-0",
  };

  const slideOutClass = {
    left: "-translate-x-10",
    right: "translate-x-10",
    top: "-translate-y-10",
    bottom: "translate-y-10",
  };

  useIntersectionObserver(targetRef, {
    onIntersect: (isIntersecting) => {
      setIsVisible(isIntersecting);
    },
    options: { threshold }, // Pass the customizable threshold
    debounceDelay, // Pass the debounce delay to avoid flickering
  });

  return (
    <div
      ref={targetRef}
      className={`${className} w-full transition-all duration-500 ease-in-out ${
        isVisible
          ? `${animationClass} ${slideInClass[direction]}`
          : `${hiddenClass} ${slideOutClass[direction]}`
      }`}
    >
      {children}
    </div>
  );
};
